import React from "react";
import {
  Box,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IMPORT_STAT_FIELDS } from "./importStatisticsLabels";

const valueColor = (highlight, value) => {
  if (highlight === "error" && value > 0) {
    return "error.main";
  }
  if (highlight === "warning" && value > 0) {
    return "warning.dark";
  }
  return "#0b3d87";
};

const ImportStatisticsPanel = ({ statistics }) => {
  if (!statistics) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          fontFamily: "Rubik",
          fontWeight: "bold",
          color: "#0b3d87",
          mb: 1.5,
        }}
      >
        Riepilogo importazione
      </Typography>

      <Grid container spacing={1.5}>
        {IMPORT_STAT_FIELDS.map((field) => {
          const value = statistics[field.key] ?? 0;
          return (
            <Grid item xs={6} sm={4} md={3} key={field.key}>
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  borderRadius: 2,
                  border: "1px solid rgba(11,61,135,0.12)",
                  backgroundColor: "#f8fbff",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 0.5,
                    mb: 0.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Rubik",
                      fontSize: 13,
                      color: "#5a6b85",
                      lineHeight: 1.3,
                    }}
                  >
                    {field.label}
                  </Typography>
                  <Tooltip title={field.tooltip} arrow placement="top">
                    <InfoOutlinedIcon
                      sx={{ fontSize: 16, color: "#5a6b85", mt: "1px", flexShrink: 0 }}
                    />
                  </Tooltip>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    fontSize: 22,
                    color: valueColor(field.highlight, value),
                  }}
                >
                  {value.toLocaleString("it-IT")}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ImportStatisticsPanel;
